import React, { useState, useEffect } from "react";
import styles from "styles/Home.module.scss";
import Card from "components/Card";
import Title from "components/Title";
import SearchBar from "components/SearchBar";
import useMakeRequest from "hooks/useMakeRequest";
import ReactPaginate from "react-paginate";
import CustomDropdown from "components/Dropdown";
import config from "../config";

const Shop = () => {
    const { data, error, isLoading } = useMakeRequest(`${config.API_BASE_URL}/products`);
    const itemsPerPage = 18;

    const [currentPage, setCurrentPage] = useState(0);
    const [sortOrder, setSortOrder] = useState("lowToHigh");
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredData, setFilteredData] = useState([]);

    useEffect(() => {
        if (data.length > 0) {
            let sortedData = [...data];

            // Filter out products with quantity <= 0
            sortedData = sortedData.filter(product => product.quantity > 0);

            // Normalize search term by trimming spaces and converting to lowercase
            const lowercasedSearchTerm = searchTerm.trim().toLowerCase();

            // Filter by search term in both title and category
            if (lowercasedSearchTerm) {
                sortedData = sortedData.filter((product) => {
                    const titleMatch = product.title && product.title.toLowerCase().includes(lowercasedSearchTerm);
                    const categoryMatch = product.category && product.category.toLowerCase().includes(lowercasedSearchTerm);
                    return titleMatch || categoryMatch;
                });
            }

            // Sort based on the selected order
            sortedData = sortedData.sort((a, b) => {
                if (sortOrder === "lowToHigh") return a.price - b.price;
                if (sortOrder === "highToLow") return b.price - a.price;
                return 0;
            });

            setFilteredData(sortedData);
        }
    }, [data, searchTerm, sortOrder]);

    const pageCount = Math.ceil(filteredData.length / itemsPerPage);
    const offset = currentPage * itemsPerPage;
    const currentItems = filteredData.slice(offset, offset + itemsPerPage);

    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
    };

    const handleSortChange = (option) => {
        setSortOrder(option.value);
        setCurrentPage(0);
    };

    const handleSearch = (query) => {
        setSearchTerm(query);
        setCurrentPage(0);
    };

    if (isLoading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    const sortOptions = [
        { label: "Bajo a Alto", value: "lowToHigh" },
        { label: "Alto a Bajo", value: "highToLow" }
    ];

    return (
        <section className={styles.home}>
            <div className={styles.background}></div>
            <div className={styles.container}>
                <div className={`${styles.row} ${styles.filterRow}`}>
                    <div className={styles.title}>
                        <Title txt="Todos los productos" color="#171717" size={22} transform="uppercase" />
                    </div>
                    <SearchBar onSearch={handleSearch} />
                    <div className={styles.filterContainer}>
                        <label htmlFor="sort">Ordenar por precio: </label>
                        <CustomDropdown options={sortOptions} selectedOption={sortOrder} onSelect={handleSortChange} />
                    </div>
                </div>
                <div className={styles.row}>
                    {currentItems.length > 0 ? (
                        currentItems.map((product, key) => <Card product={product} key={key} />)
                    ) : (
                        <div className={styles.noProducts}>
                            <Title txt="No products found" size={25} transform="uppercase" />
                        </div>
                    )}
                </div>
                {filteredData.length > itemsPerPage && (
                    <div className={styles.pagination}>
                        <ReactPaginate
                            previousLabel={<span>← Anterior</span>}
                            nextLabel={<span>Siguiente →</span>}
                            breakLabel={<span>...</span>}
                            pageCount={pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={3}
                            onPageChange={handlePageClick}
                            containerClassName={styles.paginationContainer}
                            activeClassName={styles.activePage}
                            pageClassName={styles.pageItem}
                            previousClassName={styles.pageItem}
                            nextClassName={styles.pageItem}
                        />
                    </div>
                )}
            </div>
        </section>
    );
};

export default Shop;
